import {DiditInitCreateAction, DiditInitState, DiditInitActionTypes} from "../../types/Payments/diditInit";


const initialState: DiditInitState = {
    diditInitData: {},
    loading: false,
    diditInitError: null,
};

export const diditInitReducer = (state = initialState, action: DiditInitCreateAction): DiditInitState => {
    switch (action.type) {
        case DiditInitActionTypes.POST_DIDIT_INIT_DATA:
            return { ...state, loading: true, diditInitError: null, diditInitData: [] };
        case DiditInitActionTypes.POST_DIDIT_INIT_DATA_SUCCESS:
            return { ...state, loading: false, diditInitError: null, diditInitData: action.payload };
        case DiditInitActionTypes.POST_DIDIT_INIT_DATA_ERROR:
            return { ...state, loading: false, diditInitError: action.payload, diditInitData: [] };
        default:
            return state;
    }
};
